var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.5C14 11.8137 11.3137 14.5 8 14.5M14 8.5C14 5.18629 11.3137 2.5 8 2.5M14 8.5C14 9.6046 11.3137 10.5 8 10.5C4.68629 10.5 2 9.6046 2 8.5M14 8.5C14 7.3954 11.3137 6.5 8 6.5C4.68629 6.5 2 7.3954 2 8.5M8 14.5C4.68629 14.5 2 11.8137 2 8.5M8 14.5C6.8954 14.5 6 11.8137 6 8.5C6 5.18629 6.8954 2.5 8 2.5M8 14.5C9.1046 14.5 10 11.8137 10 8.5C10 5.18629 9.1046 2.5 8 2.5M8 2.5C4.68629 2.5 2 5.18629 2 8.5",
    stroke: "#0066CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/Globe.2ebd984dca27028fa4bd452b4c5c6c0a.svg";
export { ForwardRef as ReactComponent };